<template>
  <Modal class="h-100 overflow-hidden" no-side-padding overflow-hidden @close="close">
    <div slot="modal-header" v-html="file.get('name')" />

    <vue-pdf-app :config="config3" :pdf="pdfUrl"></vue-pdf-app>
    <div slot="modal-footer">
      <el-button v-if="canShare" :loading="isSharing" @click="onShare">
        {{ $t('general.share') }}
      </el-button>
      <el-button @click="close">
        {{ $t('general.close') }}
      </el-button>
    </div>
  </Modal>
</template>

<script>
import Modal from '../atoms/Modal';
import PlatformMixin from '../../mixins/PlatformMixin';
import VuePdfApp from 'vue-pdf-app';
import { Plugins } from '@capacitor/core';
const { Share, Browser } = Plugins;

export default {
  name: 'PDFViewerModal',
  components: { Modal, VuePdfApp },
  mixins: [PlatformMixin],
  props: {
    file: {
      type: Object,
      default: () => {},
    },
  },
  async mounted() {},
  destroyed() {},
  data() {
    return {
      isLoading: false,
      isSharing: false,
      pdfData: null,
      config3: {
        toolbar: false,
      },
    };
  },
  computed: {
    canShare() {
      return (this.file.get('mediaTypeId') === 3 || this.file.get('mediaTypeId') === 9) && this.isMobile;
    },
    pdfUrl() {
      if (this.file.get('sheet')) {
        return this.file.get('sheet').url();
      } else return '';
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    async onShare() {
      this.isSharing = true;
      await Browser.open({ url: this.file.get('sheet').url() });
      setTimeout(() => {
        this.isSharing = false;
      }, 4000);
    },
  },
  onSucces() {},
  onError() {},
};
</script>

<style scoped></style>
